<template>
  <ul class="nav header-navbar-rht">

    <!-- Seletor de Idioma -->
    <li
      class="nav-item dropdown language-selector"
      :class="{ 'language-selector--disabled': idiomaBloqueadoPorAtividade }"
    >
      <a
        href="javascript:void(0)"
        class="dropdown-toggle"
        :data-bs-toggle="idiomaBloqueadoPorAtividade ? null : 'dropdown'"
        :title="idiomaBloqueadoPorAtividade ? $t('language.blockedDuringActivity') : $t('language.select')"
        @click="onLanguageSelectorClick"
      >
        <i class="feather-globe"></i>
        <span class="d-none d-md-inline ms-1">{{ currentLanguageLabel }}</span>
      </a>
      <div v-if="!idiomaBloqueadoPorAtividade" class="dropdown-menu dropdown-menu-right">
        <a
          v-for="lang in localeOptions"
          :key="lang.code"
          class="dropdown-item"
          :class="{ active: currentLocale === lang.code }"
          @click="changeLanguage(lang.code)"
        >
          <span class="flag-icon">{{ lang.flag }}</span> {{ lang.label }}
        </a>
      </div>
    </li>

    <li class="nav-item user-nav">
      <a href="javascript:void(0)" class="dropdown-toggle" data-bs-toggle="dropdown">
          <span class="user-img">
              <img v-if="usuario && usuario.Foto" :src="usuario.Foto" alt=""/>
              <img v-else-if="getTheme == 'uca'" src="../assets/img/uca/avatar-icon.png" alt=""/>
              <img v-else-if="getTheme == 'esn'" src="../assets/img/esn/avatar-icon.png" alt=""/>
              <img v-else-if="getTheme == 'u4'" src="../assets/img/u4/avatar-icon.png" alt=""/>
              <span class="status online"></span>
          </span>
        <div class="user-header float-end px-0">
          <div class="user-text" v-if="usuario">
            <h6 class="m-0">{{ usuario.Nome }}</h6>
            <p class="text-muted mb-0 text-xs" v-if="usuario.Admin">{{ $t('header.administrator') }}</p>
            <p class="text-muted mb-0 text-xs" v-else>{{ usuario.Email }}</p>
          </div>
        </div>
      </a>
      <div class="users dropdown-menu dropdown-menu-right" data-popper-placement="bottom-end">
        <a class="dropdown-item cursor-pointer" @click="this.$router.push('/perfil')"><i class="feather-user me-1"></i>
          {{ $t('header.profile') }}</a>
        <a class="dropdown-item cursor-pointer" @click="this.$router.push('/perfil/alterar-senha')"><i
          class="feather-lock me-1"></i> {{ $t('header.changePassword') }}</a>
        <a class="dropdown-item cursor-pointer" v-if="usuarioAdministrativo" @click="abrirConfiguracoes">
          <i class="feather-settings me-1"></i> {{ $t('header.settings') }}
        </a>
        <a class="dropdown-item cursor-pointer"  @click="toggleDarkMode">
          <span v-if="darkModeEnabled"><i class="feather-sun me-1"/> {{ $t('header.lightMode') }}</span>
          <span v-else><i class="feather-moon me-1"/> {{ $t('header.darkMode') }}</span>
        </a>
        <a class="dropdown-item cursor-pointer" @click="logout"><i class="feather-log-out me-1"></i> {{ $t('header.logout') }}</a>
      </div>
      <ModalConfiguracoesUsuario
        :abrir="abrirModalConfiguracoes"
        @fechar="abrirModalConfiguracoes = false"
      />
    </li>

    <li
      id="header-notificacoes-nav"
      class="nav-item dropdown noti-nav"
      v-if="temPermissaoMensagem"
      :class="{ 'noti-nav--tour': tourNotificacoesAtivo }"
    >
      <a href="javascript:void(0)" class="dropdown-toggle notification-toggle" data-bs-toggle="dropdown"
         :title="temNova ? $t('header.newNotifications') : $t('header.noNotifications')">
        <span class="notification-icon-wrap">
          <img src="../assets/img/icon/notification.svg" alt="img" class="notification-icon"
               :class="{ 'notification-icon--pulse': temNova, 'notification-icon--muted': !temNova }">
          <span
            v-if="contagemBadgeTotal"
            class="notification-badge notification-badge--total"
            :title="contagemBadgeTotalTitulo"
          >{{ contagemBadgeTotal }}</span>
        </span>
        <span v-if="temNova" class="notification-label small text-muted">
          <span class="d-block text-xs">{{ $t('header.newMessagesShort1') }}</span>
          <span class="d-block text-xs">{{ $t('header.newMessagesShort2') }}</span>
        </span>
      </a>
      <div class="notifications dropdown-menu dropdown-menu-right">
        <div
          v-if="notificacoesDropdownCarregando"
          class="notification-dropdown-loading"
        >
          <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true" />
          <span>{{ $t('header.fetchingNotifications') }}</span>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="topnav-dropdown-header">
              <span class="fw-bold text-center" v-if="Mensagens > 0">{{ $t('header.unreadMessages', { count: Mensagens }) }}</span>
              <span class="text-muted text-center" v-else>{{ $t('header.allMessagesRead') }}</span>
              <a href="javascript:void(0)" class="clear-noti" @click="irParaMensagens('email')">
                <div>{{ $t('header.goToMessages') }} <i class="fa-solid feather-chevron-right"/></div>
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="topnav-dropdown-header">
              <span class="fw-bold text-center" v-if="Notificacoes > 0">{{ $t('header.unreadNotifications', { count: Notificacoes }) }}</span>
              <span class="text-muted text-center" v-else>{{ $t('header.allNotificationsRead') }}</span>
              <a href="javascript:void(0)" class="clear-noti" @click="irParaMensagens('notificacao')">
                <div>{{ $t('header.goToNotifications') }} <i class="fa-solid feather-chevron-right"/></div>
              </a>
            </div>
          </div>
        </div>

<!--        <div class="noti-content">-->
<!--          <ul class="notification-list">-->

<!--            <li class="notification-message"-->
<!--                v-for="(notificacao, index) in MensagensNotificacao" :key="index">-->
<!--              <div class="media d-flex">-->
<!--                <div class="avatar">-->
<!--                  <img v-if="notificacao.FotoRemetente" :src="notificacao.FotoRemetente" class="avatar-img"/>-->
<!--                  <img v-else-if="getTheme == 'uca'" src="../assets/img/uca/avatar-icon.png" class="avatar-img"/>-->
<!--                  <img v-else-if="getTheme == 'esn'" src="../assets/img/esn/avatar-icon.png" class="avatar-img"/>-->
<!--                </div>-->
<!--                <div class="media-body">-->
<!--                  <h6>{{ notificacao.DisplayNomeRemetente }}</h6>-->
<!--                  <p class="noti-details">{{ notificacao.Assunto }}</p>-->
<!--                  <p class="text-xs text-muted m-0">{{ notificacao.CriadoEm }}</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->

<!--          </ul>-->
<!--        </div>-->

      </div>
    </li>

  </ul>
</template>
<script>
import authService from "../Services/Auth.service";
import userService from "../helpers/user.service.js";
import Helper from "../helpers/helper.service";
import eventBus from '../helpers/event.bus';
import MenuLogin from "../mixins/menu.login.mix";
import { useI18n } from 'vue-i18n';
import notificacaoCacheService from '../helpers/notificacao.cache.service'
import modoAlunoService from '../Services/ModoAluno.service'
import ModalConfiguracoesUsuario from './ModalConfiguracoesUsuario.vue'
import { buildLocaleOptions, shortLabelForLocale } from '../models/localizacao'
import atividadeSessaoService from '../helpers/atividadeSessao.service'
import {
  TOUR_NOTIFICACOES_ENCERRAR,
  TOUR_NOTIFICACOES_PREPARAR_DESKTOP,
} from '../helpers/helper.notificacao.tour'

export default {
  components: { ModalConfiguracoesUsuario },
  mixins: [MenuLogin],
  setup() {
    const { locale } = useI18n();
    return { locale };
  },
  data() {
    return {
      usuario: null,
      Mensagens: null,
      Notificacoes: null,
      temNova: false,
      darkModeEnabled: false,
      unsubscribeUserUpdated: null,
      onPageShowNotificacao: null,
      notificacaoIntervalId: null,
      abrirModalConfiguracoes: false,
      tourNotificacoesAtivo: false,
      onTourPrepararDesktop: null,
      onTourEncerrarDesktop: null,
      onDropdownNotificacoesShow: null,
      notificacoesDropdownCarregando: false,
      onMensagensNotificacao: null,
    }
  },
  async mounted() {

    if (this.temPermissaoMensagem) {
      this.onMensagensNotificacao = (event) => this.receberMensagensNotificacao(event)
      eventBus.addEventListener(notificacaoCacheService.EVENTO_CONTAGENS_NOTIFICACAO, this.onMensagensNotificacao)
    }

    this.onTourPrepararDesktop = () => this.prepararTourNotificacoesDesktop()
    this.onTourEncerrarDesktop = () => this.encerrarTourNotificacoesDesktop()
    eventBus.addEventListener(TOUR_NOTIFICACOES_PREPARAR_DESKTOP, this.onTourPrepararDesktop)
    eventBus.addEventListener(TOUR_NOTIFICACOES_ENCERRAR, this.onTourEncerrarDesktop)

    this.unsubscribeUserUpdated = userService.onUserUpdated(() => {
      this.usuario = userService.getUser()
      if (this.temPermissaoMensagem && this.podeVerificarNotificacao())
        void this.getNotificacao(true)
    })

    this.usuario = userService.getUser()

    if (this.temPermissaoMensagem && this.podeVerificarNotificacao()) {

      this.aplicarNotificacoesCache()

      this.onPageShowNotificacao = (event) => {
        if (event.persisted) {
          this.getNotificacao(true)
        }
      }
      window.addEventListener('pageshow', this.onPageShowNotificacao)

      if (this.foiRefreshPagina()) {
        await this.getNotificacao(true)
      } else {
        await this.getNotificacao()
      }

      this.notificacaoIntervalId = setInterval(async () => {
        if (document.visibilityState === 'visible') {
          await this.getNotificacao()
        }
      }, 60000); // 1 min

      this.registrarDropdownNotificacoes()

    }

  },
  beforeUnmount() {
    this.removerDropdownNotificacoesListener()
    if (this.onTourPrepararDesktop)
      eventBus.removeEventListener(TOUR_NOTIFICACOES_PREPARAR_DESKTOP, this.onTourPrepararDesktop)
    if (this.onTourEncerrarDesktop)
      eventBus.removeEventListener(TOUR_NOTIFICACOES_ENCERRAR, this.onTourEncerrarDesktop)
    if (this.unsubscribeUserUpdated)
      this.unsubscribeUserUpdated();
    if (this.onPageShowNotificacao)
      window.removeEventListener('pageshow', this.onPageShowNotificacao);
    if (this.notificacaoIntervalId) {
      clearInterval(this.notificacaoIntervalId)
      this.notificacaoIntervalId = null
    }
    if (this.onMensagensNotificacao) {
      eventBus.removeEventListener(notificacaoCacheService.EVENTO_CONTAGENS_NOTIFICACAO, this.onMensagensNotificacao)
      this.onMensagensNotificacao = null
    }
  },
  computed: {
    temPermissaoMensagem() {
      if (!userService.isAuthenticated())
        return false
      return userService.checkPermision('Mensagem')
    },
    usuarioAdministrativo() {
      if (!this.usuario)
        return false
      if (modoAlunoService.checkModoAluno())
        return false
      return !!(this.usuario.Admin || this.usuario.TipoUsuario === 'administrativo')
    },
    getTheme() {
      return Helper.getTheme()
    },
    currentLocale() {
      return Helper.currentLocale();
    },
    localeOptions() {
      return buildLocaleOptions(this.$t);
    },
    currentLanguageLabel() {
      return shortLabelForLocale(this.currentLocale);
    },
    idiomaBloqueadoPorAtividade() {
      return atividadeSessaoService.state.emAndamento;
    },
    contagemNaoLidasTotal() {
      const mensagens = parseInt(this.Mensagens, 10) || 0;
      const notificacoes = parseInt(this.Notificacoes, 10) || 0;
      return mensagens + notificacoes;
    },
    contagemBadgeTotal() {
      return this.formatarContagemBadge(this.contagemNaoLidasTotal);
    },
    contagemBadgeTotalTitulo() {
      const mensagens = parseInt(this.Mensagens, 10) || 0;
      const notificacoes = parseInt(this.Notificacoes, 10) || 0;
      const partes = [];
      if (mensagens > 0)
        partes.push(this.$t('header.unreadMessages', { count: mensagens }));
      if (notificacoes > 0)
        partes.push(this.$t('header.unreadNotifications', { count: notificacoes }));
      return partes.join(' · ') || this.$t('header.noNotifications');
    },
  },
  methods: {
    formatarContagemBadge(valor) {
      const n = parseInt(valor, 10);
      if (!Number.isFinite(n) || n <= 0)
        return null;
      return n > 99 ? '99+' : String(n);
    },
    avisoIdiomaBloqueadoDuranteAtividade() {
      swalAlert.fire(
        this.$t('activityPage.blockedAction'),
        this.$t('language.blockedDuringActivity'),
        'warning',
      );
    },
    onLanguageSelectorClick(event) {
      if (!this.idiomaBloqueadoPorAtividade)
        return;
      event.preventDefault();
      event.stopPropagation();
      this.avisoIdiomaBloqueadoDuranteAtividade();
    },
    abrirConfiguracoes() {
      this.fecharDropdownUsuario()
      this.abrirModalConfiguracoes = true
    },
    fecharDropdownUsuario() {
      const toggle = this.$el?.querySelector?.('.user-nav .dropdown-toggle')
      if (toggle && window.bootstrap?.Dropdown) {
        window.bootstrap.Dropdown.getOrCreateInstance(toggle).hide()
      }
    },
    irParaMensagens(tipo) {
      const destino = userService.getRotaMensagens(tipo === 'notificacao' ? 'notificacao' : null)
      this.fecharDropdownNotificacoes()
      this.$router.push(destino)
    },
    fecharDropdownNotificacoes() {
      const toggle = this.$el?.querySelector?.('.noti-nav .dropdown-toggle')
      if (toggle && window.bootstrap?.Dropdown) {
        window.bootstrap.Dropdown.getOrCreateInstance(toggle).hide()
      }
    },
    prepararTourNotificacoesDesktop() {
      if (this.tourNotificacoesAtivo)
        return
      this.tourNotificacoesAtivo = true
      this.$nextTick(() => {
        const toggle = this.$el?.querySelector?.('#header-notificacoes-nav .dropdown-toggle')
        if (!toggle)
          return
        const dropdown = window.bootstrap?.Dropdown?.getOrCreateInstance(toggle)
        if (dropdown && !toggle.classList.contains('show'))
          dropdown.show()
      })
    },
    encerrarTourNotificacoesDesktop() {
      this.tourNotificacoesAtivo = false
      this.fecharDropdownNotificacoes()
    },
    async changeLanguage(lang) {
      if (lang === this.currentLocale)
        return

      if (this.idiomaBloqueadoPorAtividade) {
        this.avisoIdiomaBloqueadoDuranteAtividade();
        return;
      }

      try {
        swalLoading.fire()
        const localizacao = Helper.toDbLocalizacao(lang)
        const result = await authService.alterarIdiomaSelecionado(localizacao)
        if (!result.Success)
          throw new Error(Helper.getMessageError(result))

        userService.saveUser(result.Data)
        this.locale = Helper.toUiLocale(result.Data?.Usuario?.Usuario?.Localizacao || localizacao)
        this.usuario = userService.getUser()
        swalLoading.close()
        window.location.reload()
      } catch (e) {
        Helper.messageExceptionHandler(e)
      }
    },
    foiRefreshPagina() {
      const [navigationEntry] = performance.getEntriesByType('navigation')
      return navigationEntry?.type === 'reload'
    },
    lerNotificacoesCache() {
      return notificacaoCacheService.lerNotificacoesCache()
    },
    salvarNotificacoesCache(mensagens, notificacoes, timestamp = Date.now()) {
      notificacaoCacheService.salvarNotificacoesCache(mensagens, notificacoes, timestamp)
    },
    aplicarNotificacoesCache() {
      const dados = this.lerNotificacoesCache()
      if (!dados) return false

      this.aplicarContagensNotificacao(dados.mensagens, dados.notificacoes)
      notificacaoCacheService.notificarContagensAtualizadas(dados.mensagens, dados.notificacoes)
      return true
    },
    aplicarContagensNotificacao(mensagens, notificacoes) {
      const m = parseInt(mensagens, 10) || 0
      const n = parseInt(notificacoes, 10) || 0
      this.Mensagens = m
      this.Notificacoes = n
      this.temNova = m > 0 || n > 0
    },
    receberMensagensNotificacao(event) {
      this.aplicarContagensNotificacao(
        event.detail?.mensagens ?? 0,
        event.detail?.notificacoes ?? 0,
      )
    },
    podeVerificarNotificacao() {
      if (!userService.isAuthenticated())
        return false

      const path = (this.$route?.path || window.location.pathname || '').toLowerCase()
      const primeiraRota = `/${path.split('/').filter(Boolean)[0] || ''}`

      if (window.rotasSemAuth?.includes(primeiraRota) || path === '/login' || path.startsWith('/login/'))
        return false

      return true
    },
    registrarDropdownNotificacoes() {
      this.$nextTick(() => {
        const nav = document.getElementById('header-notificacoes-nav')
        if (!nav)
          return
        this.onDropdownNotificacoesShow = () => {
          void this.atualizarNotificacoesAoAbrirDropdown()
        }
        nav.addEventListener('show.bs.dropdown', this.onDropdownNotificacoesShow)
      })
    },
    removerDropdownNotificacoesListener() {
      const nav = document.getElementById('header-notificacoes-nav')
      if (nav && this.onDropdownNotificacoesShow)
        nav.removeEventListener('show.bs.dropdown', this.onDropdownNotificacoesShow)
      this.onDropdownNotificacoesShow = null
    },
    async atualizarNotificacoesAoAbrirDropdown() {
      if (!this.podeVerificarNotificacao())
        return

      this.notificacoesDropdownCarregando = true
      try {
        await this.getNotificacao(true)
      } finally {
        this.notificacoesDropdownCarregando = false
      }
    },
    async getNotificacao(forcar = false) {

      if (!this.podeVerificarNotificacao())
        return

      try {
        await notificacaoCacheService.obterContagensNaoLidas({ forcar })
      } catch (e) {
        console.error('Erro ao buscar novas mensagens do usuário')
      }

    }
  },
}
</Script>

<style scoped>

.header-navbar-rht .dropdown-menu {
  min-width: 220px;
  padding: 0;
}

.topnav-dropdown-header > span {
  cursor: default;
}

.notification-dropdown-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 10px 12px;
  font-size: 12px;
  color: #6c757d;
  border-bottom: 1px solid #eee;
  text-transform: lowercase;
}

.notification-message:hover {
  cursor: default;
  background-color: #f6f6f6;
}

/* Language Selector Styles */
.language-selector .dropdown-toggle {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  color: #333;
  text-decoration: none;
}

.language-selector .dropdown-toggle:hover {
  color: #258F71;
}

.language-selector .dropdown-menu {
  padding: 8px 0;
}

.language-selector .dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.language-selector .dropdown-item:hover {
  background-color: #f6f6f6;
}

.language-selector .dropdown-item.active {
  background-color: #258F71;
  color: white;
}

.language-selector--disabled .dropdown-toggle {
  opacity: 0.55;
  cursor: not-allowed;
}

.language-selector .flag-icon {
  font-size: 18px;
}

.notification-toggle {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.notification-icon-wrap {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}


.notification-badge {
  position: absolute;
  z-index: 1;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background-color: #FF5364;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  box-sizing: border-box;
  pointer-events: none;
  border: 2px solid var(--bs-body-bg, #fff);
}

.notification-badge--total {
  top: -6px;
  right: -10px;
}

.notification-label {
  line-height: 1.1;
  text-align: left;
}

.notification-icon--muted {
  filter: grayscale(100%);
}

.notification-icon--pulse {
  animation: notification-icon-pulse 1.5s ease-in-out infinite;
}

@keyframes notification-icon-pulse {
  0%, 100% {
    filter: none;
    transform: scale(1);
  }
  50% {
    filter: drop-shadow(0 0 4px rgba(212, 23, 136, 0.55));
    transform: scale(1.06);
  }
}

</style>
